import '../MainNav/Trapdoor/TrapdoorContent/index.js';
import { TRAPDOOR_LINKS_MAP, TRAPDOOR_LINKS_MAP_UK } from '../MainNav/Trapdoor/TrapdoorContent/TrapdoorContent.js';
const MAIN_LINKS = [{
  key: 'prices',
  intlLabelKey: 'pricesTab',
  name: 'Explore',
  url: 'https://www.coinbase.com/explore',
  dataSyntheticId: 'header-price-link',
  mobileNavbarLinkUrl: '/explore',
  iconName: 'chartCandles'
}, {
  key: 'individuals',
  intlLabelKey: 'individualsTab',
  name: 'Individuals',
  subLinks: TRAPDOOR_LINKS_MAP['individuals'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'trading'
}, {
  key: 'businesses',
  intlLabelKey: 'businessesTab',
  name: 'Businesses',
  subLinks: TRAPDOOR_LINKS_MAP['businesses'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'commerceProduct'
}, {
  key: 'institutions',
  intlLabelKey: 'institutionsTab',
  name: 'Institutions',
  subLinks: TRAPDOOR_LINKS_MAP['institutions'],
  iconName: 'institutionalProduct'
}, {
  key: 'developers',
  intlLabelKey: 'developersTab',
  name: 'Developers',
  subLinks: TRAPDOOR_LINKS_MAP['developers'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'developerPlatformProduct'
}, {
  key: 'company',
  intlLabelKey: 'companyTab',
  name: 'Company',
  subLinks: TRAPDOOR_LINKS_MAP['company'],
  iconName: 'coinbase'
}];
const MAIN_LINKS_UK = [{
  key: 'prices',
  intlLabelKey: 'pricesTabUK',
  name: 'Explore',
  url: 'https://www.coinbase.com/explore',
  dataSyntheticId: 'header-price-link',
  mobileNavbarLinkUrl: '/explore',
  iconName: 'chartCandles'
}, {
  key: 'individuals',
  intlLabelKey: 'individualsTab',
  name: 'Individuals',
  subLinks: TRAPDOOR_LINKS_MAP_UK['individuals'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'trading'
}, {
  key: 'businesses',
  intlLabelKey: 'businessesTab',
  subLinks: TRAPDOOR_LINKS_MAP_UK['businesses'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'commerceProduct'
}, {
  key: 'institutions',
  intlLabelKey: 'institutionsTab',
  name: 'Institutions',
  subLinks: TRAPDOOR_LINKS_MAP_UK['institutions'],
  iconName: 'institutionalProduct'
}, {
  key: 'developers',
  intlLabelKey: 'developersTab',
  name: 'Developers',
  subLinks: TRAPDOOR_LINKS_MAP_UK['developers'],
  mobileNavbarLinkUrl: '/products',
  iconName: 'developerPlatformProduct'
}, {
  key: 'company',
  intlLabelKey: 'companyTab',
  name: 'Company',
  subLinks: TRAPDOOR_LINKS_MAP_UK['company'],
  iconName: 'coinbase'
}];
export { MAIN_LINKS, MAIN_LINKS_UK };
//# sourceMappingURL=navLinks.js.map
